import { useState, useEffect } from 'react';

const useResponsive = () => {
	const [ isMobile, setIsMobile ] = useState( window.innerWidth <= 768 );
	const [ isTablet, setIsTablet ] = useState(
		window.innerWidth > 768 && window.innerWidth <= 1024
	);

	useEffect( () => {
		const handleResize = () => {
			setIsMobile( window.innerWidth <= 768 );
			setIsTablet( window.innerWidth > 768 && window.innerWidth <= 1024 );
		};

		window.addEventListener( 'resize', handleResize );
		return () => window.removeEventListener( 'resize', handleResize );
	}, [] );

	return { isMobile, isTablet };
};

export default useResponsive;
